import React from 'react';
import Panel from '../../components/ui/Panel';
import ComponentShowcase from '../../components/ui/ComponentShowcase';
import Scrollbar from '../../components/ui/Scrollbar';

const lines = [
  'Welcome to Old School RuneScape.',
  'A goblin hits you.',
  'You bury the bones.',
  'Your Prayer level is now 10.',
  'You cook the shrimp.',
  'You burn the shrimp.',
  'Oh dear, you are dead!',
  'The bank is currently closed.',
];

const basicCode = `<Scrollbar>
  {lines.map((line) => <p key={line}>{line}</p>)}
</Scrollbar>`;

const darkCode = `<Scrollbar variant="dark">{lines}</Scrollbar>`;

const ScrollbarPage: React.FC = () => {
  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Scrollbar</h1>
      <p className="text-osrs-yellow mb-8">
        Chat and quest text scroll inside an inset track. Arrow buttons sit above and below a stone thumb. The thumb can be dragged.
      </p>

      <section id="examples" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Examples</h2>
        <ComponentShowcase
          id="basic"
          title="Chat log"
          description="Use the arrows or drag the thumb."
          component={
            <div className="w-full max-w-md h-40">
              <Scrollbar className="h-40">
                {lines.map((line) => (
                  <p key={line} className="px-2 py-1">{line}</p>
                ))}
              </Scrollbar>
            </div>
          }
          code={basicCode}
        />
        <ComponentShowcase
          id="variants"
          title="Dark track"
          description="A darker thumb for panels that are already stone."
          component={
            <div className="w-full max-w-md h-40">
              <Scrollbar variant="dark" className="h-40">
                {lines.map((line) => (
                  <p key={line} className="px-2 py-1">{line}</p>
                ))}
              </Scrollbar>
            </div>
          }
          code={darkCode}
        />
      </section>

      <section id="usage-guidelines" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Usage Guidelines</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Give the frame a fixed height so the thumb has a track.</li>
            <li>Use the default thumb on dark logs and the dark variant on lighter panels.</li>
            <li>Keep the arrow labels. They are the keyboard-free way to move the log.</li>
          </ul>
        </Panel>
      </section>

      <section id="api-reference" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">API Reference</h2>
        <Panel>
          <p className="text-osrs-yellow">
            variant is default or dark. Children render in the scrolling region. The component hides the native bar and draws the arrow buttons and thumb.
          </p>
        </Panel>
      </section>
    </div>
  );
};

export default ScrollbarPage;
